import { Injectable } from '@angular/core';
import { APIService } from '@core/services/api.service';
import { LoginRequest } from '../models/login-request.model';
import { LoginResponse } from '../models/login-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private readonly apiService: APIService) {}

  loginUser(loginRequest: LoginRequest): Observable<LoginResponse> {
    return this.apiService.post<LoginResponse>('User/Login', loginRequest);
  }
}
